import React from 'react';
import { User, Users, Activity, Target, Apple } from 'lucide-react';
import { services } from '../data/mockData';

const iconMap = {
  user: User,
  users: Users,
  activity: Activity,
  target: Target,
  apple: Apple
};

const Services = () => {
  return (
    <section id="services" className="section-padding bg-page relative z-10">
      <div className="container mx-auto px-5 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-16 scroll-reveal">
          <h2 className="heading-2 mb-6 gradient-text">השירותים שלנו</h2>
          <p className="body-medium text-secondary max-w-2xl mx-auto">
            מגוון רחב של שירותי אימון ותזונה המותאמים לכל רמה ויעד אישי
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                className="service-card group"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                {/* Image */}
                <div className="service-card-image-wrapper">
                  <img 
                    src={service.image}
                    alt={service.title}
                    className="service-card-image"
                  />
                  <div className="service-card-overlay"></div>
                  {/* Icon */}
                  <div className="service-icon">
                    <IconComponent size={40} />
                  </div>
                </div>

                {/* Content */}
                <div className="service-card-content">
                  <h3 className="heading-4 mb-4 text-primary">
                    {service.title}
                  </h3>
                  <p className="body-small text-secondary">
                    {service.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
